import { useState } from 'react';
import { Box, Modal } from '@mui/material';
import Image from 'next/image';

const VideoModal = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      {/* Clickable Image */}
      <Box
        sx={{
          cursor: 'pointer',
          position: 'relative',
          height: { xs: '45vh', sm: '60vh', md: '75vh' },
          minHeight: { sm: 384 },
        }}
        onClick={handleOpen}
      >
        <Image
          priority
          src="/images/landing-hero-new.png"
          fill
          alt="Hero Thumbnail"
          objectFit="contain"
          style={{ zIndex: 10 }}
        />
      </Box>

      {/* Modal with Video */}
      <Modal
        open={open}
        onClose={handleClose}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '90%',
            maxWidth: '960px',
            height: 'auto',
            borderRadius: '12px',
            boxShadow: 24,
            outline: 'none',
          }}
        >
          <video
            src="/videos/memvy-reel-opt.mp4"
            controls
            disablePictureInPicture
            autoPlay
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '12px',
              objectFit: 'contain',
            }}
          />
        </Box>
      </Modal>
    </>
  );
};

export default VideoModal;
